import type {
  DatasetPlanPositioningContextValues,
  DatasetPlanPositioningProps,
} from "./dataset-plan-positioning.type";
import type { Int } from "@/types";

import { useEffect, useState } from "react";

export const useDatasetPlanPositioningProvider = (
  props: DatasetPlanPositioningProps
): DatasetPlanPositioningContextValues => {
  const { dataset, loading, disabled } = props;

  const isEditable = !disabled && !loading;

  const initialCoordinates = loading ? undefined : dataset?.data;
  const [coordinates, setCoordinates] = useState(initialCoordinates);
  const [page, setPage] = useState<Int | undefined>(); // let `PositionPlanPositioning` define intial page based on marker

  useEffect(() => {
    setCoordinates(dataset?.data);
  }, [dataset]);

  return {
    ...props,
    coordinates,
    setCoordinates,
    page,
    setPage,
    isEditable,
  };
};
